import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { presenceGroups, totalProfiles } from '../data/presence';
import { SectionHeading } from './SectionHeading';
const ease = [0.23, 1, 0.32, 1] as const;
export function Presence() {
  const [openId, setOpenId] = useState<string | null>('codigo');
  return <section id="presencia" className="border-b border-hairline py-24 lg:py-32" data-id="element-170" data-mp="1qqkgs9udtxu1">
      <div className="mx-auto max-w-6xl px-6" data-id="element-171" data-mp="1qsnfrjdij1aw">
        <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-172" data-mp="1vqgmcdiq9xbp">
          <SectionHeading index="06 — Presencia" title="Dónde estoy" description="La misma identidad verificada en cada plataforma donde publico, desarrollo, transmito o trabajo. Todos estos perfiles están declarados en el schema Person del sitio." data-id="element-173" data-mp="20oqgckspurvq" />
          <p className="font-mono text-5xl font-bold text-teal" data-id="element-174" data-mp="3g4z36nhxh8md">
            {totalProfiles}
            <span className="ml-2 align-middle text-xs uppercase tracking-widest text-ink-mid" data-id="element-175" data-mp="1ozl5gwkhthwc">
              perfiles
            </span>
          </p>
        </div>

        <ul className="mt-14 divide-y divide-hairline border-y border-hairline" data-id="element-176" data-mp="1k1jku77f5air">
          {presenceGroups.map(group => {
          const open = openId === group.id;
          return <li key={group.id} data-id="element-177" data-mp="1azsjfejwvpup">
                <h3 data-id="element-178" data-mp="160z6pocg82vl">
                  <button type="button" onClick={() => setOpenId(open ? null : group.id)} aria-expanded={open} aria-controls={`presencia-${group.id}`} className="flex w-full items-center gap-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-panel focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-179" data-mp="1618vj8lrc3zp">
                    <span className="w-10 shrink-0 pl-1 font-mono text-sm text-teal" data-id="element-180" data-mp="nckdcuenscrm">
                      {String(group.links.length).padStart(2, '0')}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-181" data-mp="8m7m9yyivn95">
                      <span className="block font-mono text-lg text-ink-hi" data-id="element-182" data-mp="cp46fu3pnrf7">{group.title}</span>
                      <span className="mt-0.5 block text-[15px] text-ink-mid" data-id="element-183" data-mp="3uv8us6kujw8f">{group.note}</span>
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink-mid transition-transform duration-200 ease-out ${open ? 'rotate-180 text-teal' : ''}`} aria-hidden="true" data-id="element-184" data-mp="3pqxr3nev6vj" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-185" data-mp="hmcugbbjipod">
                  {open ? <motion.div id={`presencia-${group.id}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease
              }} className="overflow-hidden" data-id="element-186" data-mp="mlz7okrdc5x6">
                      <ul className="flex flex-wrap gap-2 pb-6 pl-1 pt-1 lg:pl-16" data-id="element-187" data-mp="2uudp057a93ih">
                        {group.links.map(link => <li key={link.url} data-id="element-188" data-mp="38oelsteocgg7">
                            <a href={link.url} target="_blank" rel="noreferrer me" className="block rounded-md border border-hairline bg-panelalt px-3 py-1.5 font-mono text-[13px] text-ink-mid transition-colors duration-150 ease-out hover:border-teal hover:text-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-189" data-mp="34m1ei0ka4ahb">
                              {link.label}
                            </a>
                          </li>)}
                      </ul>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}